import { ChangePasswordSuccessPage } from "./ChangePasswordSuccessPage";

export const ResetPasswordSuccessPage = () => {
  return <ChangePasswordSuccessPage mode="reset" />;
};
